window.onload = function() {
    var inputField = document.getElementById('txtSearch');

    // Set initial focus
    inputField.focus();

    // Refocus whenever focus is lost
    inputField.addEventListener('blur', function() {
        setTimeout(function() { inputField.focus(); }, 0);
    });
};

window.addEventListener('DOMContentLoaded', (event) => {
    $('button[data-lang]').on('click', function(e){
        e.preventDefault();
        e.stopPropagation();

        let params = 'mainlang=' + $(this).attr("data-lang") + "&type=lang&url=" + window.location.pathname;
        $.post(strAjaxPath + 'update-lang.php', params, function (data) {
            window.location.href = data;
        });
    });
})